import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Form, TextInput, Button, Loading, PasswordInput } from 'carbon-components-react';
import { toaster } from '../../helpers/toaster';
import Label from '../../components/Label/Label';
import Select from "../../helpers/FixRequiredSelect";

import MyModal from '../../components/Modal/Modal';


const UserDetailModal = ({
  mode = "create",
  open = false,
  userIndex = null,
  userData = null,
  studyIndex = null,
  onClose = () => {},
	confirmSave,
	confirmUpdate,
	userLoading,
	setUserLoading,
}) => {
  const [modalMode, setModalMode] = useState("");
  const [userInfo, setUserInfo] = useState(null);

  const usertypeList = [
    {label: "Super Admin", value: "super_admin"},
    {label: "Client Admin", value: "client_admin"},
    {label: "Client Manager", value: "client_mgr"},
  ]

  const addBtnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px",
    width: "fit-content",
    marginLeft:"18px",
  };

  const saveUser = (e) => {
    e.preventDefault();

    if (!userInfo) {
      toaster("User data is not valid!","error");
      return;
    }
    if (modalMode === "create") {
      let regInfo = userInfo;
      confirmSave(regInfo).then((data) => {
        setUserInfo(null)
      })
    } else {
      confirmUpdate(userIndex, userInfo)
    }
  };

  const getUserType = () => {
    const _usertype = userInfo?.usertype
    if (_usertype) {
      for (let utype of usertypeList) {
        if (utype.value === _usertype) {
          return utype
        }
      }
    } else {
      return null
    }
  }

  useEffect(() => {
    setModalMode(mode);
    setUserInfo(userData);
  }, [mode, userData]);

	const additionalProps = {
		className: 'some-class',
		onSubmit: saveUser
	};

  return (
    <MyModal
      modalHeading="User Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <UserModalContent>

        {
          userLoading ?
            <Loading />
            :
            <></>
        }

				<Form {...additionalProps}>

          <PartWrapper>
            <InputWrapper>
              <div style={{ marginBottom: "18px" }}>
                <TextInput
                  labelText="Email"
                  id="email"
                  value={userInfo?.email || ""}
                  onChange={e => setUserInfo({
                    ...userInfo,
                    email: e.target.value,
                  })}
                  required
                  />
              </div>
            </InputWrapper>
          </PartWrapper>

          <PartWrapper>
            <InputWrapper>
              <div style={{ marginBottom: "18px" }}>
                <TextInput
                  labelText="username"
                  id="username"
                  value={userInfo?.username || ""}
                  onChange={e => setUserInfo({
                    ...userInfo,
                    username: e.target.value,
                  })}
                  required
                />
              </div>
            </InputWrapper>
          </PartWrapper>

          <PartWrapper>
            <InputWrapper>
              <div style={{ marginBottom: "18px" }}>
                <Label>User Type</Label>
                <Select
                  id="usertype"
                  options={usertypeList}
                  value={getUserType() || {}}
                  onChange={e => setUserInfo({
                    ...userInfo,
                    usertype: e.value
                  })}
                  required
                />
              </div>
            </InputWrapper>
          </PartWrapper>

          <PartWrapper>
            <InputWrapper>
              {modalMode === "create" &&
                <div style={{ marginBottom: "18px" }}>
                  <PasswordInput
                    labelText="Password"
                    id="password"
                    value={userInfo?.password || ""}
                    onChange={e => setUserInfo({
                      ...userInfo,
                      password: e.target.value,
                    })}
                    required
                  />
                </div>
              }
            </InputWrapper>
          </PartWrapper>


          <ModalFooter>
            <Button
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}
            >Cancel</Button>

            <Button
              kind="primary"
              type="submit"
              style={addBtnStyle}
            >{ (modalMode === "create") ? "Create User" : "Update User" }</Button>
          </ModalFooter>
        </Form>
      </UserModalContent>
    </MyModal>
  );
};

export default UserDetailModal;

const UserModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const PartWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
`

const InputWrapper = styled.div`
  width: 100%;
`

const InputDisabled = styled.div`
  font-color: #666666;
  font-weight: bold;
  font-size: 1.2em;
`
